var InsuranceData = {
    "product_id": 8336385736982,
    "basic_variant": 45012553138454,
    "threshold_price": 100.00,
    "basic_variant": 45012553138454,
    "basic_price": 1.98,
    "variants": [{"name":"Basic Shipping Protection","price":"1.98","id":45012553138454},{"name":"A$2.42","price":"2.42","id":45012553171222},{"name":"A$2.53","price":"2.53","id":45012553203990},{"name":"A$2.65","price":"2.65","id":45012553236758},{"name":"A$2.76","price":"2.76","id":45012553269526},{"name":"A$2.88","price":"2.88","id":45012553302294},{"name":"A$2.99","price":"2.99","id":45012553335062},{"name":"A$3.11","price":"3.11","id":45012553367830},{"name":"A$3.22","price":"3.22","id":45012553400598},{"name":"A$3.34","price":"3.34","id":45012553433366},{"name":"A$3.45","price":"3.45","id":45012553466134},{"name":"A$3.57","price":"3.57","id":45012553498902},{"name":"A$3.68","price":"3.68","id":45012553531670},{"name":"A$3.80","price":"3.80","id":45012553564438},{"name":"A$3.91","price":"3.91","id":45012553597206},{"name":"A$4.03","price":"4.03","id":45012553629974},{"name":"A$4.14","price":"4.14","id":45012553662742},{"name":"A$4.26","price":"4.26","id":45012553695510},{"name":"A$4.37","price":"4.37","id":45012553728278},{"name":"A$4.49","price":"4.49","id":45012553761046},{"name":"A$4.60","price":"4.60","id":45012553793814},{"name":"A$4.78","price":"4.78","id":45012553826582},{"name":"A$4.97","price":"4.97","id":45012553859350},{"name":"A$5.15","price":"5.15","id":45012553892118},{"name":"A$5.34","price":"5.34","id":45012553924886},{"name":"A$5.52","price":"5.52","id":45012553957654},{"name":"A$5.70","price":"5.70","id":45012553990422},{"name":"A$5.89","price":"5.89","id":45012554023190},{"name":"A$6.07","price":"6.07","id":45012554055958},{"name":"A$6.26","price":"6.26","id":45012554088726},{"name":"A$6.44","price":"6.44","id":45012554121494},{"name":"A$6.62","price":"6.62","id":45012554154262},{"name":"A$6.81","price":"6.81","id":45012554187030},{"name":"A$7.08","price":"7.08","id":45012554219798},{"name":"A$7.36","price":"7.36","id":45012554252566},{"name":"A$7.64","price":"7.64","id":45012554285334},{"name":"A$7.91","price":"7.91","id":45012554318102},{"name":"A$8.19","price":"8.19","id":45012554350870},{"name":"A$8.46","price":"8.46","id":45012554383638},{"name":"A$8.74","price":"8.74","id":45012554416406},{"name":"A$9.02","price":"9.02","id":45012554449174},{"name":"A$9.48","price":"9.48","id":45012554481942},{"name":"A$9.94","price":"9.94","id":45012554514710},{"name":"A$10.40","price":"10.40","id":45012554580246},{"name":"A$10.86","price":"10.86","id":45012554613014},{"name":"A$11.32","price":"11.32","id":45012554645782},{"name":"A$12.01","price":"12.01","id":45012554678550},{"name":"A$12.70","price":"12.70","id":45012554711318},{"name":"A$13.39","price":"13.39","id":45012554744086},{"name":"A$14.08","price":"14.08","id":45012554776854},{"name":"A$14.77","price":"14.77","id":45012554809622},{"name":"A$15.46","price":"15.46","id":45012554842390},{"name":"A$16.15","price":"16.15","id":45012554875158},{"name":"A$16.84","price":"16.84","id":45012554907926},{"name":"A$17.53","price":"17.53","id":45012554940694},{"name":"A$18.22","price":"18.22","id":45012554973462},{"name":"A$18.91","price":"18.91","id":45012555006230},{"name":"A$19.60","price":"19.60","id":45012555038998},{"name":"A$20.29","price":"20.29","id":45012555071766},{"name":"A$20.98","price":"20.98","id":45012555104534},{"name":"A$21.67","price":"21.67","id":45012555170070},{"name":"A$22.36","price":"22.36","id":45012555235606},{"name":"A$23.05","price":"23.05","id":45012555268374},{"name":"A$25.35","price":"25.35","id":45012555333910},{"name":"A$27.65","price":"27.65","id":45012555399446},{"name":"A$29.95","price":"29.95","id":45012555563286},{"name":"A$32.25","price":"32.25","id":45012555661590},{"name":"A$34.55","price":"34.55","id":45012555759894},{"name":"A$36.85","price":"36.85","id":45012555858198},{"name":"A$39.15","price":"39.15","id":45012555956502},{"name":"A$41.45","price":"41.45","id":45012556153110},{"name":"A$43.75","price":"43.75","id":45012556284182},{"name":"A$46.05","price":"46.05","id":45012556382486},{"name":"A$55.25","price":"55.25","id":45012556480790},{"name":"A$59.85","price":"59.85","id":45012556579094},{"name":"A$64.45","price":"64.45","id":45012556677398},{"name":"A$69.05","price":"69.05","id":45012556742934},{"name":"A$78.25","price":"78.25","id":45012556775702},{"name":"A$87.45","price":"87.45","id":45012556874006},{"name":"A$96.65","price":"96.65","id":45012556939542},{"name":"A$105.85","price":"105.85","id":45012557005078},{"name":"A$115.05","price":"115.05","id":45012557103382},{"name":"A$126.55","price":"126.55","id":45012557201686},{"name":"A$138.05","price":"138.05","id":45012557299990},{"name":"A$149.55","price":"149.55","id":45012557365526},{"name":"A$161.05","price":"161.05","id":45012557431062},{"name":"A$172.55","price":"172.55","id":45012557529366},{"name":"A$184.05","price":"184.05","id":45012557627670},{"name":"A$195.55","price":"195.55","id":45012557725974},{"name":"A$207.05","price":"207.05","id":45012557791510},{"name":"A$218.55","price":"218.55","id":45012557889814}]
}

var SuppsrusProtection = {
    Init: function() {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            SuppsrusProtection.InitWithCart(cart);
            GA4.cart_item(cart);
        });
    },
    InitWithCart: function(cart) {
        var cart_total = 0,
            InsuranceValue = 0,
            Protectionstatus = SuppsrusProtection.getCookie('Protectionstatus');
        for (t = 0; t < cart.items.length; t++) {
            if (cart.items[t].handle != 'gift-card') {
                cart_total = cart_total + cart.items[t].final_line_price;
            }
        }
        cart_total = cart_total / 100;

        if (cart_total > InsuranceData.threshold_price) {
            var value = SuppsrusProtection.getClosests(cart_total, InsuranceData.variants);
            $('#insurancePrice,.template-cart #insurancePrice').html(Shopify.formatMoney(value.price * 100, window.money_format));
            if (Protectionstatus == "true") {
                InsuranceValue = value.price
            }
        } else {
            $('#insurancePrice,.template-cart #insurancePrice').html(Shopify.formatMoney(InsuranceData.basic_price * 100, window.money_format));
            if (Protectionstatus == "true") {
                InsuranceValue = InsuranceData.basic_price;
            }
        }
        if (Protectionstatus == "true") {
            $('#easy-protection, .template-cart #easy-protection').prop("checked", true);
        } else {
            $('#easy-protection, .template-cart #easy-protection').prop("checked", false);
        }

        if(SuppsrusProtection.getCookie('PriorityDispatch') == 'true'){
          $('#priority-dispatch, .template-cart #priority-dispatch').prop("checked", true);
        } else {
          $('#priority-dispatch, .template-cart #priority-dispatch').prop("checked", false);
        }

        cart_total = (Math.abs(parseFloat(cart_total) + parseFloat(InsuranceValue))) * 100;
        if(SuppsrusProtection.getCookie('PriorityDispatch') == 'true'){
          cart_total = cart_total + $('#priority-dispatch:checked').data('price');
        }
        $('.totals__subtotal-value, .satcb_checkout_price').html(Shopify.formatMoney(cart_total, window.money_format));
    },
    Checkproduct: function() {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var items = cart.items;
            GA4.cart_item(cart);
            items.forEach(function(i, v) {
                if (i.product_id == InsuranceData.product_id) {
                  $('.drawer__cart-items-wrapper .cart-item.active-easy ,#main-cart-items .cart-item.active-easy').find('.button.button--tertiary').trigger('click');
                }
                if (i.product_id == $('#priority-dispatch').val()) {
                  $('.drawer__cart-items-wrapper .cart-item.active-priority-dispatch ,#main-cart-items .cart-item.active-priority-dispatch').find('.button.button--tertiary').trigger('click');
                }
            });
        });
    },
    AddToCard: function(variant) {
      let formData = { 'items': [] };
      for(var i=0; i < variant.length; i++){
       formData.items.push({ 'id': variant[i],'quantity': 1 })
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
        navigateToCheckout();
      }).catch((error) => {
        navigateToCheckout();
      });
    },
    getClosests: function getClosests(total, variants) {
        var counts = variants,
            goal = total * 2.3 / 100;
        var closest = counts.reduce(function(prev, curr) {
            return Math.abs(parseFloat(curr.price) - parseFloat(goal)) < Math.abs(parseFloat(prev.price) - goal) ? curr : prev;
        });
        return closest;
    },
    CookieInit: function() {
        var Protectionstatus = SuppsrusProtection.getCookie('Protectionstatus');
        if (Protectionstatus == null) {
            document.cookie = "Protectionstatus=true";
        }
    },
    getCookie: function(name) {
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if (name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }
}

$(document).on('click', '#CartDrawer-Checkout, #checkout', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).attr('disabled', 'disabled');
    setTimeout(function() {
        $('#CartDrawer-Checkout, #checkout').removeAttr("disabled");
    }, 7000);
    var EasyStatus = SuppsrusProtection.getCookie('Protectionstatus');
    if (EasyStatus && EasyStatus == "true") {
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var cart_total = 0,
                InsuranceValue = 0,
                Protectionstatus = SuppsrusProtection.getCookie('Protectionstatus'),
                onlygift = true,
                checkInsurance = true;

            for (t = 0; t < cart.items.length; t++) {
                if (cart.items[t].handle != 'gift-card') {
                    cart_total = cart_total + cart.items[t].final_line_price;
                }
            }
            cart_total = cart_total / 100;

            for (i = 0; i < cart.items.length; i++) {
                var Item = cart.items[i];
                if (Item.handle != 'gift-card') {
                    if (Item.properties && Item.properties['_free-product']) {} else {
                        onlygift = false;
                    }
                }
                if (Item.handle == 'easy-insurance') {
                    checkInsurance = false;
                }
            }
            if (cart_total > InsuranceData.threshold_price) {
                var InsuranceVariant = SuppsrusProtection.getClosests(cart_total, InsuranceData.variants);
                InsuranceVariant = InsuranceVariant.id;
            } else {
                InsuranceVariant = InsuranceData.basic_variant;
            }
            if (onlygift) {
                navigateToCheckout();
            } else {
                if(checkInsurance || $('#priority-dispatch:checked').length) {
                    var AddProducts = [];
                    if($('#priority-dispatch:checked').length) AddProducts.push($('#priority-dispatch:checked').val())
                    AddProducts.push(InsuranceVariant);
                    SuppsrusProtection.AddToCard(AddProducts);
                } else {
                    navigateToCheckout();
                }
            }
        });
    } else {
        navigateToCheckout();
        return;
    }
});
$(document).on('change', '#easy-protection', function() {
  if ($(this).prop("checked") == true) {
      document.cookie = "Protectionstatus=true";
  } else {
      document.cookie = "Protectionstatus=false";
  }
  SuppsrusProtection.Init();
});

$(document).on('change', '#priority-dispatch', function() {
  if ($(this).prop("checked") == true) {
      document.cookie = "PriorityDispatch=true";
  } else {
      document.cookie = "PriorityDispatch=false";
  }
  SuppsrusProtection.Init();
});

SuppsrusProtection.Checkproduct();
SuppsrusProtection.CookieInit();
SuppsrusProtection.Init();

// Purple Dot required change
// Purple Dot's integration mounts its checkout on top of the /cart page. This checks
// the cart for the presence of an item on pre-order and redirects to /cart if necessary.
// Otherwise, it redirects to the native Shopify /checkout.
async function navigateToCheckout() {
  const cart = await fetch('/cart.js').then(res => res.json());
  
  let hasPreorder = false;
  for (let item of cart.items) {
    if (item.properties && item.properties['__releaseId']) {
      hasPreorder = true;
    }
  }

  if (hasPreorder) {
    window.location.href = '/cart';
  } else {
    window.location.href = '/checkout';
  }
}